import request from '@/utils/request/next-request';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import StreamLakeContent from '@/components/StreamLakeContent';
import { Empty } from 'antd';

type ReleasedContent = {
  docId: string;
  title: string;
  tags: string[];
  author: string;
  html: string;
  releaseAt: number;
  recommendDocs: {
    docId: string;
    title: string;
  }[];
};

// NOTE: this file name [...path] means that abstracted location of the content and usually form of [type, tag, contentId], here is definition of all types and tags could be.
const PathRegistry = {
  activity: '活动资讯',
  lvs: '2022北京 LiveVideoStackCon大会',
  publish: 'StreamLake品牌发布会',
};

const Content = () => {
  const router = useRouter();
  const [data, setData] = useState<ReleasedContent>();
  const [hasError, setHasError] = useState<boolean>(false);
  const [path, setPath] = useState<string[]>();
  const location = (router.query['path']?.slice(0, 2) as string[]) || [];
  const docId = router.query['path']?.[location.length];

  const fetchContent = async (docId: string, tag: string) => {
    if (!tag) return;
    try {
      const res = await request({
        url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/content`,
        method: 'get',
        data: {
          docId,
          tag,
        },
      });
      setData(res);
      return res;
    } catch (error) {
      setHasError(true);
    }
  };

  const handleClickRecommendDoc = (docId: string) => {
    router.push(`/content/${location.join('/')}/${docId}`);
  };

  const handleBreadCrumbClick = (index: number) => {
    router.push(`/${location.slice(0, index + 1).join('/')}`);
  };

  useEffect(() => {
    fetchContent(docId, location[1]).then((res) => {
      if (!res) return;
      const prePath = location.map((el) => PathRegistry[el]).filter((el) => el);
      setPath([...prePath, res.title || '暂无内容']);
    });
  }, [router]);

  return (
    <>
      <div className={styles['banner']}>
        <div className={styles['title']}>{path?.[0]}</div>
      </div>
      <div className={styles['wrapper']}>
        <BreadCrumb path={path} onClick={handleBreadCrumbClick} />
        <div className={styles['content']}>
          <div className={styles['container']}>
            {!data ? (
              <></>
            ) : data.docId ? (
              <StreamLakeContent
                title={data?.title}
                author={data?.author}
                date={data?.releaseAt}
                htmlContent={data?.html}
              />
            ) : (
              <Empty description={'暂无内容'} />
            )}
          </div>
          <RecommendDocs
            list={data?.recommendDocs}
            onClick={handleClickRecommendDoc}
          />
        </div>
      </div>
    </>
  );
};

const BreadCrumb = ({
  path = [],
  onClick = () => {},
}: {
  path: string[];
  onClick?: (index: number) => void;
}) => {
  return (
    <div className={styles['breadcrumbs']}>
      {path.map((item, index) => (
        <>
          <div
            className={styles['item']}
            key={item}
            onClick={() => index < path.length - 1 && onClick(index)}
          >
            {item}
          </div>
          <div className={styles['divider']} key={index} />
        </>
      ))}
    </div>
  );
};

const RecommendDocs = ({
  list = [],
  onClick = () => {},
}: {
  list: {
    docId: string;
    title: string;
  }[];
  onClick: (docId: string) => void;
}) => {
  if (list.length === 0) return null;
  return (
    <div className={styles['recommend']}>
      <div className={styles['label']}>相关文章</div>
      <div className={styles['list']}>
        {list.map((item) => (
          <div
            key={item.docId}
            className={styles['item']}
            onClick={() => onClick(item.docId)}
          >
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Content;
